import {
  SendToBack,
  Hammer,
  SprayCan,
  Box,
  SquareArrowOutUpRight,
  Boxes,
  List
} from 'lucide-react';

export const QUOTE_CATEGORIES = [
  {
    id: 'Remove & Refit',
    name: 'Remove & Refit',
    icon: SendToBack,
    hasHours: true,
    hasAmount: true,
    iconClass: 'bg-primary/5'
  },
  {
    id: 'Panel Beating',
    name: 'Panel Beating',
    icon: Hammer,
    hasHours: true,
    hasAmount: true,
    iconClass: 'bg-primary/10'
  },
  {
    id: 'Painting',
    name: 'Painting',
    icon: SprayCan,
    hasHours: false,
    hasAmount: true,
    iconClass: 'bg-primary/15'
  },
  {
    id: 'Parts',
    name: 'Parts',
    icon: Box,
    hasHours: false,
    hasAmount: true,
    iconClass: 'bg-primary/20'
  },
  {
    id: 'Outwork',
    name: 'Outwork',
    icon: SquareArrowOutUpRight,
    hasHours: false,
    hasAmount: true,
    iconClass: 'bg-primary/25'
  },
  {
    id: 'Materials',
    name: 'Materials',
    icon: Boxes,
    hasHours: false,
    hasAmount: true,
    iconClass: 'bg-primary/30'
  },
  {
    id: 'Other',
    name: 'Other',
    icon: List,
    hasHours: false,
    hasAmount: true,
    iconClass: 'bg-primary/35'
  }
];